/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cognito_Invitation_Document_TitleInputs */

const en_cognito_invitation_document_title = /** @type {(inputs: Cognito_Invitation_Document_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Access to the Recobra platform`)
};

const pt_br2_cognito_invitation_document_title = /** @type {(inputs: Cognito_Invitation_Document_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acesso à plataforma Recobra`)
};

/**
* | output |
* | --- |
* | "Access to the Recobra platform" |
*
* @param {Cognito_Invitation_Document_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const cognito_invitation_document_title = /** @type {((inputs?: Cognito_Invitation_Document_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cognito_Invitation_Document_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cognito_invitation_document_title(inputs)
	return pt_br2_cognito_invitation_document_title(inputs)
});